export enum CustomerType {
  RSW = 'RSW',
  PPW = 'PPW',
}

export interface IBrand {
  key: 'rsw' | 'ppw';
  name: string;
  title: string;
  logoWhite: string;
  logoDark: string;
  favicon: string;
  website: string;
  phone: string;
  phoneHref: string;
  helpEmail: string;
  addressLine1: string;
  addressLine2: string;
  /** Word used for the customer's own business in portal copy ("your shop" vs "your business"). */
  businessNoun: string;
  /** Referral message sentence describing the kind of prospect to refer. */
  referralProspectSentence: string;
  /** Review SMS: what the recipient chose the business for. */
  reviewSmsNeeds: string;
  /** Review SMS: what the recipient is asked to review on Google. */
  reviewSmsSubject: string;
}

export const RSW_BRAND: IBrand = {
  key: 'rsw',
  name: 'Repair Shop Websites',
  title: 'Repair Shop Websites - Client Portal',
  logoWhite: 'assets/images/rsw-logo-white.png',
  logoDark: 'assets/images/rsw-logo-dark.png',
  favicon: 'favicon.ico',
  website: 'https://www.repairshopwebsites.com',
  phone: '919.398.6171',
  phoneHref: 'tel:+19193986171',
  helpEmail: 'help@repairshopwebsites.com',
  addressLine1: '800 Benson Rd',
  addressLine2: 'Garner, NC 27529',
  businessNoun: 'shop',
  referralProspectSentence:
    'Is there somebody that you know that needs vehicle maintenance or repair? Or somebody who is looking for an auto repair shop they can trust?',
  reviewSmsNeeds: 'auto maintenance and repair needs',
  reviewSmsSubject: 'shop',
};

export const PPW_BRAND: IBrand = {
  key: 'ppw',
  name: 'ProPainter Websites',
  title: 'ProPainter Websites - Client Portal',
  logoWhite: 'assets/images/ppw-logo-white.png',
  logoDark: 'assets/images/ppw-logo-dark.png',
  favicon: 'assets/images/ppw-favicon.png',
  website: 'https://www.propainterwebsites.com',
  phone: '855.385.1134',
  phoneHref: 'tel:+18553851134',
  helpEmail: 'help@propainterwebsites.com',
  addressLine1: '800 Benson Rd',
  addressLine2: 'Garner, NC 27529',
  businessNoun: 'business',
  referralProspectSentence:
    'Is there somebody that you know that needs painting services or will soon need painting services?',
  reviewSmsNeeds: 'painting needs',
  reviewSmsSubject: 'business',
};
